import { jsx } from "react/jsx-runtime";
import { Span } from "../Text/index.js";
import { sliderMarkVariants } from "./SliderMark.variants.js";
function SliderMark({ label, value }) {
    const { mark, label: labelSlot } = sliderMarkVariants();
    return /*#__PURE__*/ jsx("div", {
        className: mark(),
        style: {
            left: `${value}%`
        },
        "data-testid": "mark",
        title: label,
        children: label && /*#__PURE__*/ jsx(Span, {
            textStyle: "body2",
            className: labelSlot(),
            children: label
        })
    });
}
export { SliderMark };
